import type { CodiGoodsItem } from 'shared/src/api';
import type { GoodsData } from '@banhala/ui-kit';
import { convertRenderDataToGoodsData } from 'shared/src/utils/convertRenderDataToGoodsData';

export const convertCodiGoodsItemToGoodsData = (
  input: CodiGoodsItem,
): GoodsData & CodiGoodsItem => {
  return {
    ...input,
    ...convertRenderDataToGoodsData(input),
  };
};
